<script>
export default {
  name: "ShowDataDialog",
  props: {
    showData: {
      visible: Boolean,
      data: {},
    }
  },
  data() {
    return {
      isFullScreen: false,
    }
  }
}
</script>

<template>
  <el-dialog
      v-dialogDrag
      :closeOnClickModal="true"
      :visible.sync="showData.visible"
      class="abow_dialog"
      top="5vh"
      width="45vw"
      :fullscreen="isFullScreen">
    <div slot="title" class="header-title">
      <div class="dgTitle">断面信息</div>
      <el-image class="dgImg2" :src="require('../../../assets/icons/dg-gb.png')" @click="showData.visible = false"></el-image>
    </div>
    <el-descriptions title="断面信息">
      <el-descriptions-item label="断面名称">{{showData.data.damnm}}</el-descriptions-item>
      <el-descriptions-item label="浸润线X终点坐标">{{showData.data.endX}}</el-descriptions-item>
      <el-descriptions-item label="浸润线Y终点坐标">{{showData.data.endY}}</el-descriptions-item>
      <el-descriptions-item label="坝类">{{showData.data.type}}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions>
      <el-descriptions-item label="轮廓列表">
        <el-table
            :data="showData.data.secoordsList"
            border
            :default-sort="{prop: 'no', order: 'ascending'}"
            style="width: 100%">
          <el-table-column
              align="center"
              label="序号"
              prop="no">
          </el-table-column>
          <el-table-column
              align="center"
              label="轮廓类型"
              width="150px"
              prop="name">
          </el-table-column>
          <el-table-column
              align="center"
              label="X坐标"
              prop="x">
          </el-table-column>
          <el-table-column
              align="center"
              label="Y坐标"
              prop="y">
          </el-table-column>
        </el-table>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions>
      <el-descriptions-item label="测点关系">
        <el-table
            :data="showData.data.sempList"
            border
            style="width: 100%">
          <el-table-column
              align="center"
              label="序号">
            <template v-slot="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="测点编号"
              width="120px"
              prop="mpnm">
          </el-table-column>
          <el-table-column
              align="center"
              label="监测项目"
              width="150px"
              prop="name">
          </el-table-column>
          <el-table-column
              align="center"
              label="管口X坐标"
              width="100px"
              prop="tbbtX">
          </el-table-column>
          <el-table-column
              align="center"
              label="管口Y坐标"
              width="100px"
              prop="tbbtY">
          </el-table-column>
          <el-table-column
              align="center"
              label="管底Y坐标"
              width="100px"
              prop="tbtpY">
          </el-table-column>
        </el-table>
      </el-descriptions-item>
    </el-descriptions>
    <span slot="footer" class="dialog-footer">
        <template>
          <el-button
              slot="reference"
              type="primary"
              @click="showData.visible = false"
              class="dgSave">确 定
          </el-button>
        </template>
    </span>
  </el-dialog>
</template>

<style scoped>

::v-deep .el-dialog {
  margin: 0 auto;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  height: 6vh;
  line-height: 6vh;
  padding: 0;
  background-color: #f9f9ff;
  position: relative;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

::v-deep .el-dialog__headerbtn {
  position: absolute;
  top: 0px;
  right: 10px;
  height: 5vh;
  line-height: 5vh;
}

::v-deep .el-dialog__body {
  padding: 10px 20px 0px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  position: absolute;
  left: 0;
  top: 5vh;
  bottom: 70px;
  right: 0;
  overflow: auto;
}

::v-deep .dialog-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  height: 70px;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  align-items: Center;
  box-sizing: border-box;
  padding-right: 20px;
}

::v-deep .el-dialog {
  height: 70%;
}

.dgTitle{
  margin-left: 2vh;
  font-family: PingFang SC;
  font-size: 1.6vh;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0vh;
  color: #323232;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
}

.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}

.dgImg2{
  position: absolute;
  right: 2vh;
  top:1.5vh;
  width: 3vh;
  height: 3vh;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

.dgClose{
  width: 8vh;
  height: 3vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #0066ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: solid 1px #53abfd;
  border-radius: 2px;
}

.dgSave{
  width: 8vh;
  height: 3vh;
  background-color: #53abfd;
  border-radius: 0vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}
</style>